export const features = [
  {
    title: 'Level Editor',
    description: 'Rename the world, change its seed, difficulty and game mode, toggle all 31 game rules, edit superflat layers, and turn experiments off again — which Minecraft will not let you do.',
    icon: 'settings',
    avatar: '/images/avatars/level-editor.png',
  },
  {
    title: 'Player Editor',
    description: 'Everyone who has ever joined. Position, health, XP, full inventory editing with impossible enchantments, status effects, tamed pets — and export a player to a file to move them to another world.',
    icon: 'users',
    avatar: '/images/avatars/player-editor.png',
  },
  {
    title: 'World Editor',
    description: 'Your whole world drawn from its own blocks. Prune the chunks you have finished with, inspect any one of them, and edit every entity, chest, sign and villager trade in it — right down to which villages exist and why one has stopped breeding. Saved structures render in 3D, too.',
    icon: 'globe',
    avatar: '/images/avatars/world-editor.png',
  },
  {
    title: 'Realms & Servers',
    description: 'Sign in with Microsoft to open your Realms: download a world, edit it like any other, and send it back. Manage players, invites, backups and settings — and connect to your own dedicated servers the same way. Every change is backed up first.',
    icon: 'cloud',
    avatar: '/images/avatars/minecraft_avatar.png',
  },
  {
    title: 'Add-on Management',
    description: 'Install, remove, reorder and update packs without touching a folder. Missing packs and unmet dependencies flagged for you, and packs patched so you keep your achievements.',
    icon: 'package',
    avatar: '/images/avatars/addons.png',
  },
  {
    title: 'Nothing Saves Until You Say So',
    description: 'Every change is staged and listed, so you can see exactly what a save would do and undo any of it. Then a full backup, kept outside the world folder, and a read-back check afterwards.',
    icon: 'shield',
    avatar: '/images/avatars/backups.png',
  },
];
